import * as React from 'react';
import b_ from 'b_';

import './index.scss';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  loading: boolean;
}

const b = b_.with('fetch-more-button');

export const FetchMoreButton: React.FC<Props> = ({ loading, children, ...rest }) => (
  <button className={b()} {...rest}>
    {loading ? <div className={b('loader')} /> : children}
  </button>
);
